import { Controller } from 'libraries/front-end-core/core/Router'
import getUrl from 'libraries/front-end-core/core/url'
import { DOCUMENTS_REVIEW } from 'constants/controllers'
import Main from './Main'

export default new Controller({
  name: DOCUMENTS_REVIEW,
  route: 'docreview/:sectionId/:documentIds',
  controller (
    Router,
    {
      scrollMain,
      url,
      query,
      params: { sectionId = null, documentIds = null }
    },
    render
  ) {
    const pageId = getUrl(DOCUMENTS_REVIEW, {
      sectionId,
      documentIds
    })
    render(
      { Main },
      {
        sectionId,
        documentIds: documentIds.split(',')
      },
      {
        searchType: 'precedents',
        className: 'precedents',
        pageId
      }
    )

    return pageId
  }
})
